export const validEnglish = new RegExp('(?![×÷])[A-Za-zÀ-ÿ]');
export const validNumber = /^[0-9]$/;
export const validMongolian = /^[А-ЯӨҮЁа-яөүё]/;
export const validRegister = /^[А-ЯӨҮЁ]{2}[0-9]{8}$/;